export const EXTERNAL_INBOX_BATCH_SIZE = 250;
